import { Model } from '@contember/schema';
import { resolveDefaultColumnType } from '@contember/schema-utils';
export class SchemaPartsFactory {
    constructor(namingConventions) {
        Object.defineProperty(this, "namingConventions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: namingConventions
        });
    }
    createEntity(entity) {
        return {
            primary: 'id',
            primaryColumn: 'id',
            tableName: this.namingConventions.getTableName(entity.name),
            fields: {
                id: {
                    name: 'id',
                    type: Model.ColumnType.Uuid,
                    columnType: 'uuid',
                    nullable: false,
                    columnName: 'id',
                },
            },
            unique: [],
            indexes: [],
            eventLog: { enabled: true },
            ...entity,
        };
    }
    createColumn(column) {
        return {
            columnType: this.createColumnType(column),
            nullable: true,
            columnName: this.namingConventions.getColumnName(column.name),
            ...column,
        };
    }
    createColumnType(columnType) {
        return columnType.type === Model.ColumnType.Enum ? columnType.columnType : resolveDefaultColumnType(columnType.type);
    }
    createRelation(entityName, relation) {
        if (relation.type === Model.RelationType.OneHasOne) {
            if ('ownedBy' in relation) {
                return {
                    nullable: true,
                    ...relation,
                };
            }
            return {
                nullable: true,
                ...relation,
                joiningColumn: {
                    columnName: this.namingConventions.getJoiningColumnName(relation.name),
                    onDelete: Model.OnDelete.restrict,
                    ...relation.joiningColumn,
                },
            };
        }
        if (relation.type === Model.RelationType.ManyHasMany) {
            if ('ownedBy' in relation) {
                return relation;
            }
            const [joiningColumn, inverseJoiningColumn] = this.namingConventions.getJoiningTableColumnNames(entityName, relation.name, relation.target, relation.inversedBy);
            return {
                ...relation,
                joiningTable: {
                    tableName: this.namingConventions.getJoiningTableName(entityName, relation.name),
                    joiningColumn: { columnName: joiningColumn, onDelete: Model.OnDelete.cascade },
                    inverseJoiningColumn: { columnName: inverseJoiningColumn, onDelete: Model.OnDelete.cascade },
                    eventLog: { enabled: true },
                    ...relation.joiningTable,
                },
            };
        }
        if (relation.type === Model.RelationType.OneHasMany) {
            return relation;
        }
        if (relation.type === Model.RelationType.ManyHasOne) {
            return {
                nullable: true,
                ...relation,
                joiningColumn: {
                    columnName: this.namingConventions.getJoiningColumnName(relation.name),
                    onDelete: Model.OnDelete.restrict,
                    ...relation.joiningColumn,
                },
            };
        }
        return ((_) => {
            throw new Error();
        })(relation);
    }
}
//# sourceMappingURL=SchemaPartsFactory.js.map